import { create } from 'zustand';

import { getMyBetaFeatureGroup } from './beta-features.api';

type BetaFeaturesState = {
  /** Beta frontend features the person's audience leaves off; null until loaded. */
  hidden: ReadonlySet<string> | null;
  /** The person the features were loaded for, so a different login loads its own. */
  loadedFor: string | null;
  load: (personId: string) => Promise<void>;
};

export const useBetaFeaturesStore = create<BetaFeaturesState>((set, get) => ({
  hidden: null,
  loadedFor: null,
  load: async (personId) => {
    if (get().loadedFor === personId) return;
    set({ hidden: null, loadedFor: personId });

    try {
      const group = await getMyBetaFeatureGroup();
      if (get().loadedFor === personId) set({ hidden: new Set(group.hidden) });
    } catch (error) {
      // Unknown stays hidden, so a beta feature never reaches someone outside its audiences.
      console.error('Failed to load beta features:', error);
    }
  },
}));
